module.exports = __webpack_public_path__ + "static/the-seekers-guide-dad129943ca515037ce2a8ca9437a178.jpg";